export const PERIODS = {
  annual: "Anual",
  month: "Mensual",
  today: "Hoy",
  trimestre: "Trimestre",
};
